import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import Layout from "../../components/layout";
import MaintenancesPricesGridComponent from "../../components/maintenancesPricesGrid";

interface Props {}

interface State {}

class MaintenancesPricesGridContainer extends React.Component<Props> {
  state = {};

  componentDidMount() {
    //this.props.getClubs();
  }

  render() {
    return (
      <main>
        <Helmet title="ReportMaintenancesPricesGrid" />
        <Layout>
          <MaintenancesPricesGridComponent />
        </Layout>
      </main>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaintenancesPricesGridContainer);
